import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import request from '../../../helpers/request';

const getExecuterList = async (serviceCompanyId) => {
  let url = '/Docs/workers';

  if (serviceCompanyId) {
    url += `?serviceCompanyId=${serviceCompanyId}`;
  }

  return await request.get(
    url,
    null,
    'Произошла ошибка при загрузке исполнителей'
  );
};

export const useExecuterListQuery = (
  { serviceCompanyId } = {},
  options = {}
) => {
  return useQuery(
    queryKeys.executerList(serviceCompanyId),
    () => getExecuterList(serviceCompanyId),
    options
  );
};

export default useExecuterListQuery;
